import React from 'react';
import Footer from '../Footer/Footer';
import modImage from '../../Assets/Images/services.jpg'; // Replace with an actual image or reuse aboutImage if needed

import './Services.css';

const Modifications = () => {
  return (
    <div className="services-page-main-sub">
      <div className="services-content-box">
        <div className="services-top-row">
          <div className="services-text-left">
            <h1>Console & Computer Modifications</h1>
            <p>
              Professional upgrades and custom modifications tailored to your video game consoles, vintage computers, and electronics.
            </p>
            <p>
              From modchip installations and RAM upgrades to custom performance enhancements, we help extend the life and capabilities of your devices.
            </p>
          </div>

          <div className="services-right-column">
            <div className="services-image-right">
              <img src={modImage} alt="Console & Computer Modifications" />
            </div>
          </div>
        </div>

        <div className="services-bottom-text">
          <p>
            Our expertise in PCB assembly and board-level work ensures your modifications are performed with precision and reliability.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Modifications;
